<template>
	<div class="animate_animated animate__slideInRight">
		<div class="fixed w-full top-0 left-0 z-20">
		 <div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
			<div class="h-1 bg-gradient-to-r from-amber-500 to-amber-200"></div>
			 <div class="flex items-center px-4 py-4">
				<div class="w-2/3">
				<div class="flex items-center w-full">
					<a  @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
					<span class="text-base text-content font-medium ml-4">Matching Properties</span>
				</div>
			</div>
			<div class="w-1/3">
				<div class="flex items-center justify-end">
					<a href="" class="mx-2 relative"><img src="@/assets/share.svg" alt="" >
						<span class="w-3 h-3 flex bg-primary  text-white items-center justify-center rounded-full text-xxs absolute -top-1 -right-1">2</span>
					</a>
					<a href="" class="mx-2"><img src="@/assets/search-icon.svg" alt=""></a>
					<a href="" class="mx-2"><img src="@/assets/filter-icon.svg" alt=""></a>
				</div>
			</div>
			 </div>
			
		</div>
		</div>
<!-- Card-List -->
<div class="pt-16 mt-2">
		<div class="shadow-ct bg-white my-4">
			<div class="flex items-center p-2 border-b border-divider">
				<div class="w-1/3">
					<img src="@/assets/property-image.png" alt="" class="rounded  h-28 w-full object-cover object-center">
				</div>
				<div class="w-2/3">
					<div class="p-3">
						<div class="flex items-center mb-1">
							<span class="text-xs text-content text-opacity-40 mr-1">2 months ago</span>
							<span class="text-xs bg-primary text-white font-medium rounded-full px-3 mr-1">Sale</span>
							<span class="text-xs text-success font-medium">Available</span>
						</div>
						<h2 class="text-content text-sm font-medium mb-1">2 BHK Flat In Goodwill Paradise</h2>
						<div class="flex items-center mb-1">
							<img src="@/assets/location.svg" alt="" class="mr-1"> <span
								class="text-content text-xs text-opacity-50">Deccan, Pune</span>
						</div>
						<div class="flex items-center ">
							<span class="text-xs text-content font-medium">Rs 99.0 Lacs</span>
							<span class="mx-2 text-divider">|</span>
							<span class="text-xs text-content font-medium">1250 sq.ft</span>
						</div>
					</div>
				</div>
			</div>
			<div class="flex items-center p-4">
			
				<div class="w-full">
					<div class="flex items-center justify-end">
						<a href="" class="mx-4"><img src="@/assets/whatsapp.svg" alt=""></a>
						<a href="" class="mx-4"><img src="@/assets/email-icon.svg" alt=""></a>
						<a href="" class="mx-4"><img src="@/assets/phone-icon.svg" alt=""></a>
					</div>
				</div>
			</div>
		</div>

		<!--Card-List -->
		<div class="shadow-ct bg-white my-4">
			<div class="flex items-center p-2 border-b border-divider">
				<div class="w-1/3">
					<img src="@/assets/property-image.png" alt="" class="rounded  h-28 w-full object-cover object-center">
				</div>
				<div class="w-2/3">
					<div class="p-3">
						<div class="flex items-center mb-1">
							<span class="text-xs text-content text-opacity-40 mr-1">2 months ago</span>
							<span class="text-xs bg-primary text-white font-medium rounded-full px-3 mr-1">Rent</span>
							<span class="text-xs text-red font-medium">Sold</span>
						</div>
						<h2 class="text-content text-sm font-medium mb-1">2 BHK Flat In Goodwill Paradise</h2>
						<div class="flex items-center mb-1">
							<img src="@/assets/location.svg" alt="" class="mr-1"> <span
								class="text-content text-xs text-opacity-50">Deccan, Pune</span>
						</div>
						<div class="flex items-center ">
							<span class="text-xs text-content font-medium">Rs 99.0 Lacs</span>
							<span class="mx-2 text-divider">|</span>
							<span class="text-xs text-content font-medium">1250 sq.ft</span>
						</div>
					</div>
				</div>
			</div>
			<div class="flex items-center p-4">
			
				<div class="w-full">
					<div class="flex items-center justify-end">
						<a href="" class="mx-4"><img src="@/assets/whatsapp.svg" alt=""></a>
						<a href="" class="mx-4"><img src="@/assets/email-icon.svg" alt=""></a>
						<a href="" class="mx-4"><img src="@/assets/phone-icon.svg" alt=""></a>
					</div>
				</div>
			</div>
		</div>

		<!-- Add Button -->
		<!-- <a href="" class="fixed bottom-0 right-0 m-4 flex items-center justify-center w-14 h-14 bg-primary rounded-full">
			<img src="@/assets/plus-icon.svg" alt="">
		</a> -->
</div>
	</div>
</template>
<style scoped>

</style>